import {
  GET_ACCIDENT_HISTORY,
  SHOW_ACCIDENT_HISTORY,
  CREATE_ACCIDENT_HISTORY,
  EDIT_ACCIDENT_HISTORY,
  DELETE_ACCIDENT_HISTORY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_ACCIDENT_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/accident_histories",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_ACCIDENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/accident_histories/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_ACCIDENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/accident_histories/accident_history_create";
      const res = await dispatch("apiPost", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_ACCIDENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/accident_histories/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_ACCIDENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/accident_histories/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
